module.exports = __webpack_public_path__ + "static/media/snack-madness-banner-mobile.5acc5bd5.png";